import { render, staticRenderFns } from "./xModal.vue?vue&type=template&id=27f28a79&scoped=true&"
import script from "./xModal.vue?vue&type=script&lang=js&"
export * from "./xModal.vue?vue&type=script&lang=js&"
import style0 from "./xModal.vue?vue&type=style&index=0&id=27f28a79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f28a79",
  null
  
)

export default component.exports